import '@myosh/odin-translations/i18n';
import { applyStoredColorScheme } from '@myosh/design-system';
import { AuthProvider, UserProvider } from '@myosh/myosh-login';
import { TooltipProvider } from '@myosh/odin-components';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { ToastContainer } from 'react-toastify';
import App from '@/App.tsx';
import store from '@/redux/store.ts';
import './index.css';

applyStoredColorScheme();

const root = document.getElementById('root')!;

createRoot(root).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <AuthProvider>
          <UserProvider>
            <TooltipProvider>
              <App />
              <ToastContainer position="top-center" hideProgressBar />
            </TooltipProvider>
          </UserProvider>
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  </StrictMode>
);
